<template>
  <myhead :value="value" @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="avatar">
    <!-- <p class="avatar__p">个人信息</p> -->
    <van-uploader :after-read="afterRead">
      <div>
        <img :src="userinfo.head_pic" class="uploader__avatar  pointer">
        <img src="@/assets/img/icon37.png" class="uploader__icon pointer">
      </div>
    </van-uploader>
  </div>
  <div class="userinfo">
    <div class="userinfo-list">
      <div>
        <label for="" class="userinfo-list__label">用户名</label>
        <input type="text" ref="nickname" class="userinfo-list__input" v-model="userinfo.nickname" @input="watchnickname">
      </div>
      <p @click="handleEdit" class="userinfo-list__btn">{{ edit }}</p>
    </div>
    <p class="smallsize">4-20个字符，仅支持中英文、数字、下划线，不含敏感词汇</p>
    <div class="height20px"></div>
    <div class="userinfo-list ">
      <div>
        <label for="" class="userinfo-list__label">身份证号</label>
        <input type="text" class="userinfo-list__input color999" v-model="userinfo.idcard" disabled>
      </div>
    </div>
    <div class="userinfo-list">
      <div>
        <label for="" class="userinfo-list__label">姓名</label>
        <input type="text" class="userinfo-list__input color999" v-model="userinfo.realname" disabled>
      </div>
    </div>
    <div class="userinfo-list">
      <div>
        <label for="" class="userinfo-list__label">民族</label>
        <input type="text" class="userinfo-list__input color999" v-model="userinfo.nation" disabled>
      </div>
    </div>
    <div class="userinfo-list">
      <div>
        <label for="" class="userinfo-list__label">出生年月</label>
        <input type="text" class="userinfo-list__input color999" v-model="userinfo.birthday" disabled>
      </div>
    </div>
    <div class="userinfo-list">
      <div>
        <label for="" class="userinfo-list__label">手机号</label>
        <input type="text" class="userinfo-list__input color999" v-model="userinfo.mobile" disabled>
      </div>
    </div>
    <!-- <div class="userinfo-list userinfo-textarea-list">
            <div>
                <label for="" class="userinfo-list__label">住址</label>
                <textarea type="text" class="userinfo-list__textarea" v-model="userinfo.address" disabled></textarea>
            </div>
        </div> -->
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { getUserInfo, changeUserInfo, postImg } from "@/api/center.js";
import { getLocalUserInfo } from "@/utils/type.js";
import { nextFn } from "@/utils/type.js";
import { showSuccessToast } from 'vant';
import { useStore } from "vuex";
//右箭头
const next = () => {
  nextFn()
}

const nickname = ref()
const edit = ref("编辑")

const userinfo = ref({
  head_pic: "",
  nickname: "",
  idcard: "",
  realname: "",
  nation: "",
  birthday: "",
  mobile: "",
  address: ""
});
const store = useStore();
getUserInfo().then(res => {
  if (res.errcode === 1) {
    const userData = res.data
    userinfo.value = userData
  }
})

const handleEdit = async () => {
  if (edit.value === "编辑") {
    nickname.value.disabled = false
    edit.value = "保存"
  } else {
    const data = {
      typeid: 2,
      nickname: userinfo.value.nickname
    }
    const saveData = await changeUserInfo(data)
    if (saveData.errcode === 1) {
      nickname.value.disabled = true
      showSuccessToast("修改成功")
      edit.value = "编辑"
      const localUserInfo = getLocalUserInfo()
      localUserInfo.nickName = userinfo.value.nickname
      localStorage.setItem('loginInfo', JSON.stringify(localUserInfo))
      userinfo.value.nickname = saveData.data.nickname
    }
  }
};

//读取文件上传文件
const afterRead = async (file) => {
  const fileData = {
    "file": file.file
  }
  const backData = await postImg(fileData)
  if (backData.errcode === 1) {

    const localUserInfo = getLocalUserInfo()
    localUserInfo.headPic = backData.data.img
    localStorage.setItem('loginInfo', JSON.stringify(localUserInfo))
    userinfo.value.head_pic = backData.data.img
    const postHeadImg = {
      typeid: 1,
      head_pic: backData.data.url
    }
    const uploadImg = await changeUserInfo(postHeadImg)
    console.log(uploadImg)
    store.state.loginInfo.headPic = backData.data.img;
  }
}

// function checkval(t) {
//    var re = /^[\u4e00-\u9fa5a-z]+$/gi;//只能输入汉字和英文字母
//   if (re.test(t)) {
//      return true;
//    } else {
//      return false;
//    }
//  }
//监听昵称输入
const oldval = ref('')
const watchnickname = () => {
  //限制长度
  let len = 0
  userinfo.value.nickname.match()
  const strArr = userinfo.value.nickname.split('')
  strArr.forEach(item => {
    const is = item.match(/[\u4E00-\u9FA5]/)
    if (is) {
      len += 2
    } else {
      len += 1
    }
  })
  if (len > 20) {
    userinfo.value.nickname = oldval.value
  } else {
    oldval.value = userinfo.value.nickname
  }
  // let s = checkval(userinfo.value.nickname)
  // console.log(s)
}
onMounted(() => {
  nickname.value.disabled = true
})
</script>
<style scoped>
    .avatar {
        position: relative;
        width: 17.6vw;
        height: 17.6vw;
        padding-top: 5.6vw;
        padding-left: 4vw;
    }
    .avatar__p {
        display: block;
        min-width: 200px;
        font-size: 16px;
        color: #000000;
        font-weight: 700;
        margin-bottom: 2.9333vw;
    }
    .uploader__avatar {
        display: block;
        width: 60px;
        max-width: 60px;
        height: 60px;
        border-radius: 50%;
        object-fit: cover;
    }
    .uploader__icon {
        position: absolute;
        width: 4.8vw;
        bottom: 0;
        right: 0;
    }
    /* 列表 */
    .userinfo {
        margin-top: 16vw;
    }
    .userinfo-list {
        padding: 4vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid #f6f6f6;
    }
    
    .userinfo-list>div {
        display: flex;
        flex-direction: row;
    }
    .userinfo-list__label {
        color: #999999;
        font-size: 14px;
        width: 20.8vw;
    }
    .userinfo-list__input {
        width: 58.6667vw;
        border: 0;
        outline: 0;
        font-size: 14px;
        color: #333333;
        background-color: #fff;
    }
    .color999{
        color: #999;
    }
    .userinfo-list__btn {
        font-size: 14px;
        color: #3F7C93;
    }
    .userinfo-list__textarea {
        width: 63.4667vw;
        border: 0;
        outline: 0;
        background-color: #fff;
    }
    .userinfo-textarea-list > div {
        align-items: center;
    }
    .smallsize {
        font-size: 12px;
        color: red;
        padding-left: 4vw;
    }
</style>
